import React from 'react';
import NavbarInv from '../../components/navbarInv';
import DetallesDeptoInv from '../../formDataInv/detallesDeptoCapisInv';

function BeneficiarioDetallesDepartamento() {
    return (
        <div className='flex flex-col justify-start'>
            {/* <NavbarInv /> */}
            <DetallesDeptoInv />
        </div>
    )
}

export default BeneficiarioDetallesDepartamento;